import React, { useContext, useEffect } from 'react'
import UserContext from '../contexts/UserContext'
import { MozrestVenue } from '../models/MozrestVenue'
import useFetch from '../hooks/useFetch'
import MozrestListManager from '../mozrest/MozrestListManager'
import { getMozrestVenue } from '../config/apiRoutes'
import MozrestInfo from '../mozrest/MozrestInfo'

type Props = {}

const MozrestPage = (props: Props) => {
    const { user, hasFeature, selectedRestaurant } = useContext(UserContext);
    const [mozrestVenue, setMozrestVenue] = React.useState<MozrestVenue | null>(null);
    const venueCaller = useFetch();
    const [showListingManager, setShowListingManager] = React.useState(false);
    const [showMozrestInfo, setShowMozrestInfo] = React.useState(false);

    useEffect(() => {
        if (selectedRestaurant && hasFeature("LISTING_MANAGER")) {
            fetchMozrestVenue();
        } else {
            setMozrestVenue(null);
            setShowListingManager(false);
            setShowMozrestInfo(true);
        }
    }, [selectedRestaurant]);

    async function fetchMozrestVenue() {
        const response = await venueCaller.call<any, any>("GET", getMozrestVenue.replace(":restaurantShortName", selectedRestaurant!.restaurantShortName));
        if (response && response.data) {
            setMozrestVenue(response.data);
            setShowListingManager(true);
            setShowMozrestInfo(false);
        } else {
            setMozrestVenue(null);
            setShowListingManager(false);
            setShowMozrestInfo(true);
        }
    }


    return (
        <div>
            {showListingManager && mozrestVenue && (
                <MozrestListManager venue={mozrestVenue} />
            )}
            {showMozrestInfo && (
                <MozrestInfo
                    onCreated={() => fetchMozrestVenue()}
                />
            )}
        </div>
    )
}

export default MozrestPage